<template>
    <div class="achievements">
        绩效管理
    </div>
</template>
<script>
export default {
    name: 'achievements',
    data() {
        return {

        }
    }
}
</script>
<style scss='less' scoped>

</style>